import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/arrow-right-line.svg'

type SvgProps = React.ComponentProps<typeof SvgComponent>

const Svg: React.FC<SvgProps> = (props) => <SvgComponent {...props} />

const Icon = withSvgProps(Svg)

export const ArrowRightLine: React.FC<React.ComponentProps<typeof Icon>> = (
  props,
) => <Icon {...props} fill="none" stroke />
